import React from 'react';

import Logo from './../images/logo.png';
import Chevron from './../images/chevron.png';

import { Link } from 'react-router-dom';

import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

import HomeImage from './../images/home-image.png';
import PremiumImage from './../images/premium-logo.png';
import { useUser } from './../hooks/useUser';

import Spinner from './../components/spinner';


import './premium-test.scss';



import { useFirebaseServices } from './../hooks/firebase-services.js';




const PremiumTest = ({ priceAmount, currency, setSignUpFlow, setPremiumModalOpen }) => {

  const [purchaseButtonClicked, setPurchaseButtonClicked] = useState(false);

  const { user } = useUser();

  const { checkout } = useFirebaseServices();

  if (priceAmount == null || currency == null) {

    return (<div className="flex-center"> <Spinner /> </div>);

  }

  const shortPrice = priceAmount.toString().slice(0, -2);
  const capsCurrency = currency.toString().toUpperCase();


  return (
    <div >

      <div className="premium-test-box">
        <div className="test-option-image-container" >
          <img className="test-option-image" src={PremiumImage} alt="home-image" />
        </div>

        <div className="normal-flex-divider vertical-center">
          <div className="test-option-heading">
            Full-test
          </div>

          <div className="test-option-heading-large">
            $ {shortPrice}   {capsCurrency}
          </div>

        </div>

        <div>
          Full test to give you the most in-depth results. You will gain access to your exact percentile score and additional information to help you understand your personality.   </div>


        <ul>
          <div className="list-item">
            < div className="list-circle" />
            <li>Extended Strengths + Weaknesses results</li>
          </div>
          <div className="list-item">
            < div className="list-circle" />
            <li>Relationships and friendships results</li>
          </div>
          <div className="list-item">
            < div className="list-circle" />
            <li>Work recommendations</li>
          </div>
          <div className="list-item">
            < div className="list-circle" />
            <li>Access to all facet combinations</li>
          </div>
          <div className="list-item">
            < div className="list-circle" />
            <li>More features to come</li>
          </div>
        </ul>

        {purchaseButtonClicked ? <Spinner /> :
          <>
            {!user ?


              <Link to="/profile">
                <button className="button secondary" onClick={() => {
                  setPremiumModalOpen(false);
                  setSignUpFlow('register');
                }}>
                  <div className="button-text">
                    Purchase
                  </div>
                  <img className="button-icon" src={Chevron} alt="chevron" />
                </button>
              </Link>

              :


              <button className="button secondary" onClick={() => {
                setPurchaseButtonClicked(true);
                checkout();
              }}>
                <div className="button-text">
                  Purchase
                </div>
                <img className="button-icon" src={Chevron} alt="chevron" />
              </button>


            }
          </>
        }
      </div>

    </div>
  );
}

export default PremiumTest;
